// extracted by mini-css-extract-plugin
export default {"wrap":"chapterSelect_wrap__njp+R","trigger":"chapterSelect_trigger__Yg5o6","placeholder":"chapterSelect_placeholder__+Aa+-","error":"chapterSelect_error__e5K-h"};